<template>
  <div class="shares-wrapper">
    <section class="share-line">
      分享链接
    </section>
    <ul class="share-btn_lists bdsharebuttonbox  bdshare-button-style0-16" >
      <li>
        <a  class="bds_tsina share-icon" data-cmd="tsina">
        </a>
        <p class="share-text">新浪微博</p>
      </li>

      <li>
        <a class="bds_weixin share-icon" data-cmd="weixin">
        </a>
        <p class="share-text">微信</p>
      </li>
      <li>
        <a class="bds_tieba share-icon" data-cmd="tieba">
        </a>
        <p class="share-text">百度贴吧</p>
     
      </li>
      <li>
        <a class="bds_qzone share-icon" data-cmd="qzone">
        </a>
        <p class="share-text">QQ空间</p>
      
      </li>
      <li>
        <a class="bds_copy share-icon" data-cmd="copy">
        </a>
        <p class="share-text">复制网址</p>

      </li>
    </ul>
 
  </div>
</template>

<script>

export default {
  name:"share",
  beforeCreate(){
      const _this=this;
      setTimeout(()=>{
          _this.initShare()
      },0)
  },
  methods:{
        initShare(){      
            window._bd_share_config={
                "common":{
                    "bdSnsKey":{},
                    "bdText":"",
                    "bdMini":"1",
                    "bdPic":"",
                    "bdStyle":"0",
                    "bdSize":"16",
                    "bdMiniList": false,
                },
                "share":{},
                "image":{
                    "viewList":["qzone","tsina","tqq","renren","weixin"],
                    "viewText":"分享到：","viewSize":"16"
                },
                "selectShare":{
                    "bdContainerClass":null,
                    "bdSelectMiniList":["qzone","tsina","tqq","renren","weixin"]
                }
            };
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = '/static/api/js/share.js?cdnversion='+~(-new Date()/36e5);
            document.body.appendChild(s);
        },
    
         
  },
  mounted(){
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/base.scss';

.share-line{
  color:rgba(140,140,140,1);
  font-size:pxtorem(12px);
  text-align: center;
  padding:pxtorem(32px) 0 pxtorem(20px);
  width:px2vw(315px);
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &::after{
    display: block;
    content:"";
    width:pxtorem(110px);
    height: pxtorem(1px);
    background:rgba(179,179,179,1);
    float: right;
  }
   &::before{
    display: block;
    content:"";
    width:pxtorem(110px);
    height: pxtorem(1px);
    background:rgba(179,179,179,1);
    float: left;

  }
}
.bdshare_popup_bg{
  display: none;
}
.share-btn_lists{
  display: flex;
  justify-content: space-between;
  padding:0 pxtorem(25px) ;
  &::after{
    display: none;
  }
  li{
    display: flex;
    align-items: center;
    flex-direction: column;
    a{
      background:none;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding:0;
      height: auto;
      margin:0 auto;
      
      &.share-icon{
        width:pxtorem(38px);
        height: pxtorem(38px);
        border-radius: 100%;
      }
      &.bds_tsina{
        @include bg('../../assets/images/m_share_weibo@3x.png');
        box-shadow:0px 0px 5px 0px rgba(220,68,67,0.4);
        
      }
      &.bds_weixin{
        @include bg('../../assets/images/m_share_wechat@3x.png');
        box-shadow:0px 0px 5px 0px rgba(12,234,96,0.5);
      }
      &.bds_tieba{
        @include bg('../../assets/images/m_share_baidu@3x.png');
        box-shadow:0px 0px 5px 0px rgba(8,50,209,0.5);
      }
      &.bds_qzone{
        @include bg('../../assets/images/m_share_qzone@3x.png');
        box-shadow:0px 0px 5px 0px rgba(244,161,0,0.5);
      }
      &.bds_copy{
        @include bg('../../assets/images/m_share_copy@3x.png');
      }
      
    }
  }
  .share-text{
    font-size:pxtorem(12px);
    color:rgba(89,89,89,1);
    margin-top:pxtorem(6px);
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ShareItem.vue